import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../lib/api";
import { SITE } from "../constants/site";

export const buildWhatsAppMessage = (items, total, orderId) =>
  `Bonjour ${SITE.name},\nJe souhaite commander :\n${items.map((i) => `• ${i.name} × ${i.qty} — ${formatPrice(i.price * i.qty)}`).join("\n")}\nTotal : ${formatPrice(total)}${orderId ? `\nRéf. commande : ${orderId}` : ""}`;

export const CartDrawer = () => {
  const { items, setQty, remove, total, open, setOpen } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="flex w-full flex-col p-0 sm:max-w-md">
        <SheetHeader className="border-b border-navy/10 px-6 py-5">
          <SheetTitle className="font-display text-xl text-navy">Votre panier</SheetTitle>
        </SheetHeader>
        <div data-lenis-prevent className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 ? (
            <div data-testid="cart-empty" className="grid h-full place-items-center text-center text-slate-500">
              <div><ShoppingBag className="mx-auto h-10 w-10 text-navy/20" /><p className="mt-4 text-sm">Votre panier est vide.</p></div>
            </div>
          ) : (
            <ul className="divide-y divide-navy/10">
              {items.map((i) => (
                <li key={i.id} data-testid={`cart-item-${i.id}`} className="flex gap-4 py-4">
                  <img src={i.image} alt={i.name} className="h-20 w-20 shrink-0 object-cover bg-ice" />
                  <div className="flex flex-1 flex-col">
                    <p className="eyebrow text-royal">{i.category}</p>
                    <p className="font-display text-sm font-semibold text-navy">{i.name}</p>
                    <div className="mt-auto flex items-center justify-between">
                      <div className="flex items-center border border-navy/15">
                        <button data-testid={`cart-minus-${i.id}`} onClick={() => setQty(i.id, i.qty - 1)} className="grid h-8 w-8 place-items-center hover:bg-ice"><Minus className="h-3 w-3" /></button>
                        <span data-testid={`cart-qty-${i.id}`} className="w-8 text-center text-sm font-semibold">{i.qty}</span>
                        <button data-testid={`cart-plus-${i.id}`} onClick={() => setQty(i.id, i.qty + 1)} className="grid h-8 w-8 place-items-center hover:bg-ice"><Plus className="h-3 w-3" /></button>
                      </div>
                      <span className="text-sm font-bold text-navy">{formatPrice(i.price * i.qty)}</span>
                    </div>
                  </div>
                  <button data-testid={`cart-remove-${i.id}`} onClick={() => remove(i.id)} className="self-start text-slate-400 hover:text-red-500"><Trash2 className="h-4 w-4" /></button>
                </li>
              ))}
            </ul>
          )}
        </div>
        {items.length > 0 && (
          <div className="border-t border-navy/10 px-6 py-5">
            <div className="flex items-center justify-between">
              <span className="text-sm text-slate-500">Sous-total</span>
              <span data-testid="cart-total" className="font-display text-2xl font-bold text-navy">{formatPrice(total)}</span>
            </div>
            <p className="mt-1 text-xs text-slate-400">Livraison estimée à la commande · Dakar</p>
            <div className="mt-5 grid gap-3">
              <button data-testid="cart-checkout-button" onClick={() => { setOpen(false); setTimeout(() => navigate("/commande"), 250); }} className="btn-primary justify-center">Passer la commande</button>
              <a
                data-testid="cart-whatsapp-button"
                href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(buildWhatsAppMessage(items, total))}`}
                target="_blank" rel="noreferrer"
                className="btn-wa justify-center"
              >
                Commander par WhatsApp
              </a>
            </div>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
